import React, { memo } from 'react';
import { LottieGif } from '@Sage/ssm-web5';
import { Spacer, Text, useTheme } from '@Sage/hoi-poi-ui';
import AbsoluteLoader from 'components/AbsoluteLoader';
import SageMobileLogo from 'components/SageMobileLogo';
import useLoginLiterals from 'utils/literals/useLoginLiterals';
import invitationErrorLottie from './invitationErrorLottie.json';

import './styles.scss';

const SageMobileError = memo(() => {
    const theme = useTheme();

    const { loading: literalsLoading, getLiteral } = useLoginLiterals();
    const t = getLiteral;

    if (literalsLoading) {
        return (
            <div className="sage-mobile-error">
                <AbsoluteLoader size="massive" />
            </div>
        );
    }

    return (
        <div className="sage-mobile-error">
            <div className="sage-mobile-error__content">
                <SageMobileLogo />
                <Spacer y={4} />
                <Text type="h3" isBold>
                    {t('label_invalid_invitation_title')}
                </Text>
                <Spacer y={2} />
                <Text type="body" color={theme.colors.textLight.secondary}>
                    {t('label_invalid_invitation_description_1')}
                </Text>
                <Spacer y={1} />
                <Text
                    type="body"
                    color={theme.colors.textLight.secondary}
                    className="sage-mobile-error__description"
                >
                    {t('label_invalid_invitation_description_2')}
                </Text>
                <Spacer y={2} />
                <div className="sage-mobile-error__gif">
                    <LottieGif src={invitationErrorLottie} width="250px" height="250px" />
                </div>
            </div>
        </div>
    );
});

export default SageMobileError;
